import axios from 'axios';
import get from 'lodash.get';
import { from } from 'rxjs';

export const postagePurchase = (amount, userId, sellerLabelProviderId) => {
  const post = axios
    .post('/postage/purchase', {
      amount,
      userId,
      sellerLabelProviderId,
    })
    .then((response) => {
      return get(response, 'data');
    });

  const post$ = from(post);
  return post$;
};

export const insurancePurchasePromise = ({ value, code = 'USD' }) => {
  return axios
    .post('/insurance/purchase', {
      value: Number(value),
      code,
    })
    .then((response) => {
      return get(response, 'data');
    });
};

export const insurancePurchase = (amount) => {
  const post = insurancePurchasePromise({ value: amount });
  return from(post);
};
